import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const airTicketHistorySlice = createSlice({
  name: "airTicketHistory",

  initialState: { airTicketHistory: [] },
  reducers: {
    setAllAirTicketHistory: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.airTicketHistory = payload;
    },
    resetAllAirTicketHistory: (state) => {
      state.airTicketHistory = [];
    },
  },
});

export const { setAllAirTicketHistory, resetAllAirTicketHistory } =
  airTicketHistorySlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default airTicketHistorySlice.reducer;
